// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaBlueSky_root__Hspnn"};